import base from './base'
import error from './error'
import info from './info'
import gray from './gray'
import primary from './primary'
import secondary from './secondary'
import success from './success'
import warning from './warning'

const darkColors = {
    base,
    error,
    info,
    gray,
    primary,
    secondary,
    success,
    warning
}

export default darkColors
